import { render, staticRenderFns } from "./NewInventoryList.vue?vue&type=template&id=594ef281&scoped=true&"
import script from "./NewInventoryList.vue?vue&type=script&lang=js&"
export * from "./NewInventoryList.vue?vue&type=script&lang=js&"
import style0 from "./NewInventoryList.vue?vue&type=style&index=0&id=594ef281&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ef281",
  null
  
)

export default component.exports